import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from "../../../Components/Grid/Grid";
import GdprRequestForm from "../../../Components/gdpr/GdprRequestForm";
import GdprHistoryTable from "../../../Components/gdpr/GdprHistoryTable";
import GdprRetentionPoliciesTable from "../../../Components/gdpr/GdprRetentionPoliciesTable";
import settingsActions from "../../../Actions/settingsActions";
import formActions from "../../../Actions/formActions";
import { RegexLib } from "../../../Constants/formValidationRules";

const GDPR_FORM_ID = 'gdprRequestForm';

const getValidationRules = (type) => {
    const rules = [
        { inputId: 'value', rule: 'required', message: 'Value is required' }
    ];
    
    if (type === 'custNo') {
        rules.push({ inputId: 'value', rule: RegexLib.customerNumber, message: 'Customer number must be exactly 7 digits' });
    } else if (type === 'email') {
        rules.push({ inputId: 'value', rule: RegexLib.email, message: 'Invalid email address format' });
    }
    
    return rules;
};

function GdprContainer() {
    const dispatch = useDispatch();
    
    const histories = useSelector(state => state.SettingsReducer?.gdprHistories || []);
    const policies = useSelector(state => state.SettingsReducer?.gdprRetentionPolicies || []);
    const form = useSelector(state => state.FormReducer?.forms?.[GDPR_FORM_ID]);

    useEffect(() => {
        const initialData = {
            type: 'custNo',
            value: '',
            isDryRun: true
        };
        
        const validationRules = getValidationRules(initialData.type);
        
        dispatch(formActions.startFormEditing(GDPR_FORM_ID, initialData, validationRules));
        
        return () => {
            dispatch(formActions.cancelFormEditing(GDPR_FORM_ID));
        };
    }, [dispatch]);
    
    useEffect(() => {
        if (form?.data?.type) {
            const validationRules = getValidationRules(form.data.type);
            dispatch(formActions.updateFormValidationRules(GDPR_FORM_ID, validationRules));
        }
    }, [form?.data?.type]);
    
    useEffect(() => {
        dispatch(settingsActions.getGdprHistories());
        dispatch(settingsActions.getGdprRetentionPolicies());
    }, [dispatch]);

    const handleSubmit = () => {
        if (!form) return;
        
        dispatch(formActions.submitForm(form, () => {
            // TODO: Implement GDPR request submission
            console.log('GDPR Request formdata:', form.data);
            
            // Refresh histories after submission
            dispatch(settingsActions.getGdprHistories());
        }));
    };
    
    if (!form) {
        return null;
    }
    
    return (
        <Grid>
            <Grid.Row>
                <Grid.Row.Column width={3}>
                    <GdprRequestForm
                        form={form}
                        onSubmit={handleSubmit}
                    />
                </Grid.Row.Column>
                <Grid.Row.Column>
                    <GdprRetentionPoliciesTable policies={policies} />
                </Grid.Row.Column>
                <Grid.Row>
            </Grid.Row>
                <Grid.Row.Column width={12}>
                <GdprHistoryTable histories={histories} />
                </Grid.Row.Column>
            </Grid.Row>
        </Grid>
    );
}

export default GdprContainer;